export const ballots = [
  { value: 'pr', label: 'PR', electionType: 'lge' },
  { value: 'ward', label: 'Ward', electionType: 'lge' },
  { value: 'nat', label: 'National', electionType: 'npe' },
  { value: 'reg', label: 'Regional', electionType: 'npe' },
  { value: 'prov', label: 'Provincial', electionType: 'npe' }
]

export const elections = [
  { value: 'npe2024', label: 'NPE 2024' },
  { value: 'lge2021', label: 'LGE 2021' },
  { value: 'npe2019', label: 'NPE 2019' },
  { value: 'lge2016', label: 'LGE 2016' },
  { value: 'npe2014', label: 'NPE 2014' },
  { value: 'lge2011', label: 'LGE 2011' },
  { value: 'npe2009', label: 'NPE 2009' },
  { value: 'lge2006', label: 'LGE 2006' },
  { value: 'npe2004', label: 'NPE 2004' },
  { value: 'lge2000', label: 'LGE 2000' }
]

export const levels = [
  { value: 'prov', label: 'Province' },
  { value: 'dist', label: 'District council' },
  { value: 'muni', label: 'Municipality' },
  { value: 'ward', label: 'Ward' },
  { value: 'vd', label: 'Voting district' }
]
